export default [
    {
        name: 'Serviços',
        url: '/gescon/aprovadores/servicos',
        icon: 'fa fa-truck',
        regras: 'GESCON-COMP-APROV-00'
    }
]
